
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/shuttles",
      function () {
        return require("private-next-pages/services/shuttles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/shuttles"])
      });
    }
  